import { Typography, Box, useTheme, TextField, Divider, Grid, Autocomplete, FormControlLabel, Switch, Card, Paper, CardContent, Checkbox, Tooltip, IconButton, Stack, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../../Layout/Alertbar";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,



} from "@mui/material";




import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import BintypeMasterMenu from "./ActionMenu";
import StorageLocationMenu from "./ActionMenu";

import { AddCircleOutline, Cancel, CheckBox, Inventory2, LocationOn, PanoramaFishEye, ViewAgenda, Warehouse, WarehouseOutlined } from "@mui/icons-material";

import { max } from "date-fns";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import { styled } from "@mui/material";


import AddNewBintypeMaster from "../bintype-master/AddNewBintypeMaster";
import WHAddUpdateLocationType from "../masterwarehouselocationtype/WHAddUpdateLocationType";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";

import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import { DataGrid } from "@mui/x-data-grid";
import AddNewWarehouse from "../warehouse-master/AddNewWarehouse";
import VisibilityIcon from "@mui/icons-material/Visibility"
import RequiredLabel from "../../../components/RequiredLabel";
import useWarehouseBinTypeList from "../../../hooks/warehouse/useWarehouseBinTypeList";
import useWarehouseList from "../../../hooks/warehouse/useWarehouseList";
import useStorageLocationTypeList from "../../../hooks/warehouse/useStorageLocationTypeList";
import useWarehouseStorageLocationListByID from "../../../hooks/warehouse/useWarehouseStorageLocationListByID";
import { useWarehouseBinUsage } from "../../../hooks/warehouse/useWarehouseBinUsage";



const AddNewStorageLocation = ({ handleBackWinderMachineEntry, selectedWarehouseBinTypes, warehouseStorageLocationLevelList }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const userPermissions = useUserPermissions();
    const [result, setresult] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [locationFormData, setLocationFormData] = useState({});
    const [visibleDelete, setVisibleDelete] = useState(false);
    const [bintypeid, setBintypeid] = useState(0);
    const [header, setHeader] = useState(0);
    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [enableRejectParentRoll, setEnableRejectParentRoll] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
    const [binUsagePopup, setBinUsagePopup] = useState(false); // popup toggle

    const { warehouseDetailList,
        selectedWarehouse,
        selectedWarehouseID,
        setSelectedWarehouse,
        setSelectedWarehouseID,
        loadWarehouseByID, } = useWarehouseList(true, 0);
    const { warehouseBinTypes, selectedWarehouseBinType, selectedWarehouseBinTypeID, setSelectedWarehouseBinType, setSelectedWarehouseBinTypeID, loadWarehouseBinTypeByID } = useWarehouseBinTypeList(true, 0);
    const { storageLocationTypes, selectedStorageLocationType, selectedStorageLocationTypeID, setSelectedStorageLocationType, setSelectedStorageLocationTypeID, loadStorageLocationTypeByID } = useStorageLocationTypeList(true, 0);
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const [length, setLength] = useState(0);

    const [disableWarehouse, setDisableWarehouse] = useState(false);
    const [disableBintype, setDisableBintype] = useState(false);
    const [disableLocationtype, setDisableLocationtype] = useState(false);



    const [maxweightinkg, setMaxWeightInKg] = useState(0);
    const [maxvolume, setMaxVolume] = useState(0);
    const [maxitemcount, setMaxItemCount] = useState(0);
    const [allowmixeditems, setAllowMixedItems] = useState(false);
    const [allowmixedbatches, setAllowMixedBatches] = useState(false);
    const [locationTableData, setLocationTableData] = useState([]);

    const [isEditMode, setIsEditMode] = useState(false);
    const [visibleBinlevelConfiguration, setVisibleBinlevelConfiguration] = useState(true);
    const [visibleDimentionsAndRestrictions, setVisibleDimentionsAndRestrictions] = useState(true);
    const [isWarehouseOpen, setIsWarehouseOpen] = useState(false);
    const [isBintypeOpen, setIsBintypeOpen] = useState(false);
    const [isLocationtypeOpen, setIsLocationtypeOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const { warehouseStorageLocationListByID,
        setWarehouseStorageLocationListByID,
        loadWarehouseStorageLocationBySelectedID, } = useWarehouseStorageLocationListByID();
    const { binUsage, checkWarehouseBinUsage } = useWarehouseBinUsage();
    const [levels, setLevels] = useState([
        { id: 'Level 1', enabled: false, label: '', count: 0 },
        { id: 'Level 2', enabled: false, label: '', count: 0 },
        { id: 'Level 3', enabled: false, label: '', count: 0 },
        { id: 'Level 4', enabled: false, label: '', count: 0 },
        { id: 'Level 5', enabled: false, label: '', count: 0 }
    ]);

    // --- map rows for DataGrid
    const rows = locationTableData.map(r => ({ ...r, id: r.location_id }))

    // Handle switch changes
    const handleSwitchChange = (id, field) => {
        setLocationTableData((prev) =>
            prev.map((row) =>
                row.location_id === id ? { ...row, [field]: !row[field] } : row
            )
        );
    };

    //     const [selectedLocationId, setSelectedLocationId] = useState(null);

    // const handleViewBins = (locId) => {
    //   setSelectedLocationId(locId)
    // }



    // --- columns IN SAME ORDER as your Table
    const columns = [
          
        {
            field: "code",
            headerName: "LOCATION CODE",
            width: 180,
            headerAlign: "center",
            align: "center"
        },

        // EXACT ORDER from your Table
        ...[
            "width_in_cm",
            "length_in_cm",
            "height_in_cm",
            "max_weight_in_kg",
            "max_volume",
            "max_item_count"
        ].map(field => ({
            field,
            headerName: field.replace(/_/g, " ").toUpperCase(),
            width: 120,
            headerAlign: "center",
            align: "center",
            editable: true,
            type: "number"
        })),

        {
            field: "allow_mixed_item",
            headerName: "MIXED ITEMS",
            width: 120,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <Checkbox
                    size="small"
                    checked={params.value}
                    onChange={() =>
                        handleSwitchChange(params.row.location_id, "allow_mixed_item")
                    }
                    color="secondary"
                />
            )
        },
        {
            field: "allow_mixed_batches",
            headerName: "MIXED BATCHES",
            width: 120,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <Checkbox
                    size="small"
                    checked={params.value}
                    onChange={() =>
                        handleSwitchChange(params.row.location_id, "allow_mixed_batches")
                    }
                    color="secondary"
                />
            )
        },
      {
            field: "view_bins",
            headerName: "",
            width: 10,
            headerAlign: "center",
            align: "center",
            sortable: false,
            renderCell: (params) => (
                <Tooltip title="View Bin usage">
                <IconButton
                    size="small"
                    color="secondary"
                    //   onClick={() => handleViewBins(params.row.location_id)}
                    onClick={async () => {
                        await checkWarehouseBinUsage(params.row.location_id);
                        setBinUsagePopup(true);
                    }}
                >
                    <VisibilityIcon fontSize="small" />
                </IconButton>
                </Tooltip>
            )
        },


    ]

    const usageCols = [
        { field: "is_stackable", headerName: "Stackable", width: 120 },
        { field: "vertical_gap_in_cm", headerName: "Gap (cm)", width: 120 },
        { field: "used_length_in_cm", headerName: "Used Length", width: 140 },
        { field: "used_height_in_cm", headerName: "Used Height", width: 140 },
        { field: "used_item_count", headerName: "Item Count", width: 120 },
    ];




    const handleChange = (index, field, value) => {
        const updated = [...levels];
        updated[index][field] = value;
        setLevels(updated);
    };

    // Handle numeric field changes
    const handleFieldChange = (id, field, value) => {
        setLocationTableData((prev) =>
            prev.map((row) =>
                row.location_id === id ? { ...row, [field]: value } : row
            )
        );
    };

    // const activeLevels = levels.filter(l => l.enabled);
    // const totalCombinations = activeLevels.reduce((acc, lvl) => acc * (lvl.count || 1), 1);

    const activeLevels = levels.filter(l => l.enabled);
    const totalCombinations =
        activeLevels.length > 0
            ? activeLevels.reduce((acc, lvl) => acc * (lvl.count || 1), 1)
            : 0;

    const clear = () => {

        setSelectedWarehouse(null);
        setSelectedWarehouseBinType(null);
        setSelectedStorageLocationType(null);
        setWidth(0);
        setLength(0);
        setHeight(0);
        setMaxWeightInKg(0);
        setMaxVolume(0);
        setMaxItemCount(false);
        setAllowMixedItems(false);
        setAllowMixedBatches(false);
        setLevels([
            { id: 'Level 1', enabled: false, label: '', count: 0 },
            { id: 'Level 2', enabled: false, label: '', count: 0 },
            { id: 'Level 3', enabled: false, label: '', count: 0 },
            { id: 'Level 4', enabled: false, label: '', count: 0 },
            { id: 'Level 5', enabled: false, label: '', count: 0 }
        ]);
        setIsEditMode(false); // reset to Save mode when cleared
        setVisibleBinlevelConfiguration(true);
        setVisibleDimentionsAndRestrictions(true);
        setLocationTableData([]);
        setLoading(false);
        setDisableWarehouse(false);
        setDisableBintype(false);
        setDisableLocationtype(false);
        setHeader(0);
        loadWarehouseByID(null);
loadWarehouseBinTypeByID(null);
loadStorageLocationTypeByID(null);


    }





    useEffect(() => {
        if (selectedWarehouseBinTypes !== null && selectedWarehouseBinTypes !== undefined && warehouseStorageLocationLevelList.length > 0) {
            LoadExitingWarehouseList();
        }
        else {
            clear();
        }
    }, [selectedWarehouseBinTypes, warehouseStorageLocationLevelList]);

    const LoadExitingWarehouseList = () => {

        setLoading(true);

        loadWarehouseByID(selectedWarehouseBinTypes.warehouse_id);
        loadWarehouseBinTypeByID(selectedWarehouseBinTypes.bin_type_id);
        loadStorageLocationTypeByID(selectedWarehouseBinTypes.location_type_id);

        setLocationTableData(warehouseStorageLocationLevelList);
        setIsEditMode(true); // reset to Save mode when cleared
        setVisibleBinlevelConfiguration(false);
        setVisibleDimentionsAndRestrictions(false);
        setDisableWarehouse(true);
        setDisableBintype(true);
        setDisableLocationtype(true);
        setHeader(1);

        setLoading(false);


    }



    useEffect(() => {
        if (
            selectedWarehouseID !== null &&
            selectedWarehouseBinTypeID !== null &&
            selectedStorageLocationTypeID !== null
            && selectedWarehouseBinTypes === null
        ) {
            const row = {
                warehouse_id: selectedWarehouseID,
                location_type_id: selectedStorageLocationTypeID,
                bin_type_id: selectedWarehouseBinTypeID,
            };

            loadWarehouseStorageLocationBySelectedID(row);
        }
    }, [selectedWarehouseID, selectedWarehouseBinTypeID, selectedStorageLocationTypeID]);

    // separate effect — trigger toast *only once* when data is fetched
    useEffect(() => {
        if (warehouseStorageLocationListByID && warehouseStorageLocationListByID.length > 0) {
            setLoading(true);
            setLocationTableData(warehouseStorageLocationListByID);
            setIsEditMode(true);
            setVisibleBinlevelConfiguration(false);
            setVisibleDimentionsAndRestrictions(false);
            setDisableWarehouse(true);
            setDisableBintype(true);
            setDisableLocationtype(true);
            setHeader(1);

            toast.warning('Location already available in location master.', {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
            setLoading(false);
        }
    }, [warehouseStorageLocationListByID]);

    const handleUpdateLocationTableData = () => {

        let isValid = true;
        let validation_msg = '';

        if (locationTableData.length === 0) {
            validation_msg += 'Storage locations not found.\n';
            isValid = false;
        }


        if (isValid) {
            const SaveData = {
                p_company_id: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_updated_by: localStorage.getItem('LoginID'),
                p_levels: locationTableData
            };

            callApi(Warehouse_API_ENDPOINTS.storageLocation.update, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data.length > 0) {

                            toast.success(data[0].message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 3000 // 3 seconds
                            });

                            setIsEditMode(true);
                            setVisibleBinlevelConfiguration(false);
                            setVisibleDimentionsAndRestrictions(false);
                            return;
                        }
                        else {
                            toast.error(data[0].message, { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000 });
                            return;
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                    return;
                });
        } else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
            return;
        }



    }

    const handleDeleteWarehouseLocations = () => {


        if (window.confirm("Are you sure you want to delete Warehouse Locations?")) {
        }
        else {
            // If user cancels, exit the function
            return;
        }


        let isValid = true;
        let validation_msg = '';

        if (selectedWarehouseID === null || selectedWarehouseID === undefined) {
            validation_msg += 'Please select a Warehouse.\n';
            isValid = false;
        }

        if (selectedWarehouseBinTypeID === null || selectedWarehouseBinTypeID === undefined) {
            validation_msg += 'Please select a Bin type.\n';
            isValid = false;
        }


        if (isValid) {
            const SaveData = {
                p_warehouse_id: selectedWarehouseID,
                p_bin_type_id: selectedWarehouseBinTypeID,
                p_location_type_id: selectedStorageLocationTypeID
            };

            callApi(Warehouse_API_ENDPOINTS.storageLocation.validate_and_delete, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {


                        if (data[0].message === 'OK to delete — no bins are in use.') {

                            toast.success('Storage Location deleted successfully.!', {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 3000 // 3 seconds
                            });

                            handleBackWinderMachineEntry();
                        }
                        else {
                            toast.error(data[0].message, { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000 });
                            return;
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                    return;
                });
        } else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
            return;
        }



    }

    const handlesavebintypedetails = (mode, id) => {
        setParentRollMsgOpen(false);

        if (mode === 'DELETE') {
            if (window.confirm("Are you sure you want to delete Warehouse Location?")) {
            }
            else {
                // If user cancels, exit the function
                return;
            }
        }


        let isValid = true;
        let validation_msg = '';
        if (selectedWarehouseID === null || selectedWarehouseID === undefined) {
            validation_msg += 'Please select a Warehouse.\n';
            isValid = false;
        }

        if (selectedWarehouseBinTypeID === null || selectedWarehouseBinTypeID === undefined) {
            validation_msg += 'Please select a Bin type.\n';
            isValid = false;
        }
        if (selectedStorageLocationTypeID === null || selectedStorageLocationTypeID === undefined) {
            validation_msg += 'Please select a Storage Location type.\n';
            isValid = false;
        }
        if (width <= 0) {
            validation_msg += 'Please enter Width greater than 0.\n';
            isValid = false;
        }
        if (length <= 0) {
            validation_msg += 'Please enter Length greater than 0.\n';
            isValid = false;
        }
        // ✅ Validation for at least one level having count > 0
        const hasValidCount = levels.some(level => Number(level.count) > 0);

        if (!hasValidCount) {
            validation_msg += 'Please enter count for at least one level.\n';
            isValid = false;
        }

        if (isValid) {
            const SaveData = {
                p_warehouse_id: selectedWarehouseID,
                p_bin_type_id: selectedWarehouseBinTypeID,
                p_location_type_id: selectedStorageLocationTypeID,
                p_length_in_cm: length ? parseFloat(length) : 0,
                p_width_in_cm: width ? parseFloat(width) : 0,
                p_height_in_cm: height ? parseFloat(height) : 0,
                p_max_weight_in_kg: maxweightinkg ? parseFloat(maxweightinkg) : 0,
                p_max_volume: maxvolume ? parseFloat(maxvolume) : 0,
                p_max_item_count: maxitemcount ? parseInt(maxitemcount) : 0,
                p_allow_mixed_items: allowmixeditems,
                p_allow_mixed_batches: allowmixedbatches,
                p_company_id: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_created_by: localStorage.getItem('LoginID'),
                p_levels: levels
            };

            setLoading(true);


            let API = bintypeid === 0 ? Warehouse_API_ENDPOINTS.storageLocation.generate : Warehouse_API_ENDPOINTS.WAREHOUSE_BIN_TYPE_UPDATE;

            callApi(API, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data.length > 0 && data[0].message !== 'Location already available in location master.') {

                            toast.success(data[0].message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 3000 // 3 seconds
                            });
                            setLocationTableData(data);
                            setIsEditMode(true);
                            setVisibleBinlevelConfiguration(false);
                            setVisibleDimentionsAndRestrictions(false);
                            setLoading(false);
                        }


                        else if (data[0].message === 'Location already available in location master.') {

                            toast.warning(data[0].message, { position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000 });

                            setLocationTableData(data);
                            setIsEditMode(true);
                            setVisibleBinlevelConfiguration(false);
                            setVisibleDimentionsAndRestrictions(false);
                            setDisableWarehouse(true);
                            setDisableBintype(true);
                            setDisableLocationtype(true);
                            setHeader(1);

                            setLoading(false);
                        }
                        else {
                            toast.error(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        } else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }
    };

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'save') {

            if (!hasPermission(userPermissions, "Storage Location", "Create")) {
                toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.TOP_CENTER });
                return; // Exit the function if permission is not granted
            }

            handlesavebintypedetails();
        }
        else if (buttonName === 'update') {
            if (!hasPermission(userPermissions, "Storage Location", "Update")) {
                toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.TOP_CENTER });
                return; // Exit the function if permission is not granted
            }
            handleUpdateLocationTableData();
        }
        else if (buttonName === 'clear') {

            clear();
        }
        else if (buttonName === 'delete') {
            if (!hasPermission(userPermissions, "Storage Location", "Delete")) {
                toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.TOP_CENTER });
                return; // Exit the function if permission is not granted
            }
            handleDeleteWarehouseLocations();
        }


    };

    useEffect(() => {
        if (!selectedWarehouseBinType) return;

        setLevels((prevLevels) =>
            prevLevels.map((level, index) => {
                const levelNum = index + 1;
                const enabledKey = `level${levelNum}_enabled`;
                const labelKey = `level${levelNum}_label`;

                return {
                    ...level,
                    enabled: selectedWarehouseBinType[enabledKey] ?? false,
                    label: selectedWarehouseBinType[labelKey] ?? '',
                };
            })
        );
    }, [selectedWarehouseBinType]);


    const handleWarehouseChange = (event, newValue) => {
        if (newValue !== null && newValue !== undefined) {
            loadWarehouseByID(newValue.warehouse_id);
        }
        else {
            setSelectedWarehouse(null);
            setSelectedWarehouseID(null);

        }

    };
    const handleWarehouseBinTypeChange = async (event, newValue) => {

        if (newValue === null || newValue === undefined) {
            setSelectedWarehouseBinType(null);
            setSelectedWarehouseBinTypeID(null);
            setLevels((prevLevels) =>
                prevLevels.map((level) => ({
                    ...level,
                    enabled: false,
                    label: '',
                }))
            );

        } else {
            await loadWarehouseBinTypeByID(newValue.bin_type_id);

        }



    };

    const handleStorageLocationChange = (event, newValue) => {
        if (newValue !== null && newValue !== undefined) {
            loadStorageLocationTypeByID(newValue.location_type_id);
        }
        else {
            setSelectedStorageLocationType(null);
            setSelectedStorageLocationTypeID(null);
        }

    };

    const handleBack = () => {

        setIsWarehouseOpen(false);
        setIsBintypeOpen(false);
        setIsLocationtypeOpen(false);
        loadWarehouseByID(0);
        loadWarehouseBinTypeByID(0);
        loadStorageLocationTypeByID(0);
    }






    return (

        <>

            {!isWarehouseOpen && !isBintypeOpen && !isLocationtypeOpen && (
                <Box

                    fullWidth

                >
                    <>
                        <StorageLocationMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} enableRejectParentRoll={enableRejectParentRoll} title={header} callback={handleBackWinderMachineEntry} saveButtonDisabled={saveButtonDisabled} visibleDelete={visibleDelete}
                            isEditMode={isEditMode}
                            setIsEditMode={setIsEditMode}
                        />
                        <Divider />
                    </>

                    <ResponsiveBox
                        customMaxHeight={{
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '85vh', // Large devices (desktops)
                            xl: '82vh', // Extra large devices (large desktops)
                        }}>


                        <Box p={2} spacing={2} >

                            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                            <Grid container spacing={2} sx={{ width: '100%', p: 0.5 }} >
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                    <Grid container spacing={1} sx={{ mt: 0 }}>
                                        <Grid item xs={12} lg={2}>
                                           
                                            <RequiredLabel label={'Warehouse'}/>
                                        </Grid>

                                        <Grid item xs={11} lg={4}>

                                            <Autocomplete
                                                fullWidth
                                                value={selectedWarehouse}
                                                disabled={disableWarehouse}
                                                onChange={handleWarehouseChange}
                                                size="small"
                                                options={warehouseDetailList}
                                                getOptionLabel={(option) => `${option.code}`}
                                                renderInput={(params) =>
                                                    <TextField required
                                                        color="secondary"
                                                        placeholder="Select Warehouse"
                                                        helperText={errorMessage}
                                                        error={errorMessage && errorMessage.length ? true : false}
                                                        {...params} variant="outlined" />}
                                            />
                                        </Grid>

                                        <Grid item xs={1} lg={1}>

                                            <Tooltip title="Add New Warehouse">
                                                <IconButton onClick={() => setIsWarehouseOpen(true)}>
                                                    <AddCircleOutline color="secondary" />
                                                </IconButton>
                                            </Tooltip>



                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={1} sx={{ mt: 0 }}>
                                        <Grid item xs={12} lg={2}>
                                      
                                              <RequiredLabel label={'Bin type'}/>
                                        </Grid>

                                        <Grid item xs={11} lg={4}>

                                            <Autocomplete
                                                fullWidth
                                                disabled={disableBintype}
                                                value={selectedWarehouseBinType}
                                                onChange={handleWarehouseBinTypeChange}
                                                size="small"
                                                options={warehouseBinTypes}
                                                getOptionLabel={(option) => `${option.code}`}
                                                renderInput={(params) =>
                                                    <TextField required
                                                        color="secondary"
                                                        placeholder="Select Bin Type"
                                                        helperText={errorMessage}
                                                        error={errorMessage && errorMessage.length ? true : false}
                                                        {...params} variant="outlined" />}
                                            />
                                        </Grid>

                                        <Grid item xs={1} lg={1}>
                                            <Tooltip title="Add New Bin type">
                                                <IconButton onClick={() => setIsBintypeOpen(true)}>
                                                    <AddCircleOutline color="secondary" />
                                                </IconButton>
                                            </Tooltip>

                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={1} sx={{ mt: 0 }}>
                                        <Grid item xs={12} lg={2}>
                                    
                                                    <RequiredLabel label={'Location type'}/>
                                        </Grid>

                                        <Grid item xs={11} lg={4}>
                                            <Autocomplete
                                                fullWidth
                                                disabled={disableLocationtype}
                                                value={selectedStorageLocationType}
                                                onChange={handleStorageLocationChange}
                                                size="small"
                                                options={storageLocationTypes}
                                                getOptionLabel={(option) => `${option.code}`}
                                                renderInput={(params) =>
                                                    <TextField required
                                                        color="secondary"
                                                        placeholder="Select Location Type"
                                                        helperText={errorMessage}
                                                        error={errorMessage && errorMessage.length ? true : false}
                                                        {...params} variant="outlined" />}
                                            />
                                        </Grid>

                                        <Grid item xs={1} lg={1}>

                                            <Tooltip title="Add New Location type">
                                                <IconButton onClick={() => setIsLocationtypeOpen(true)}>
                                                    <AddCircleOutline color="secondary" />
                                                </IconButton>
                                            </Tooltip>



                                        </Grid>

                                    </Grid>

                                    {visibleDimentionsAndRestrictions && (
                                        <>
                                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                                <Grid item xs={12} lg={2}>
                                                    <Typography variant="h6">Dimensions (cm)</Typography>

                                                                   
                                                </Grid>

                                                <Grid item xs={11} lg={4}>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <TextField
                                                            size="small"
                                                            type="number"
                                                            color="secondary"
                                                            placeholder="Width"
                                                            required
                                                            label="Width"
                                                            value={width}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (/^\d*\.?\d*$/.test(val)) setWidth(val);
                                                            }}
                                                            sx={{ width: 100 }}
                                                        />




                                                        <Typography variant="h6" textAlign={'center'} sx={{ width: 25 }} color="text.secondary">
                                                            ×
                                                        </Typography>

                                                        <TextField
                                                            size="small"
                                                            type="number"
                                                            color="secondary"
                                                            label="Length"
                                                            required
                                                            placeholder="Length"
                                                            value={length}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (/^\d*\.?\d*$/.test(val)) setLength(val);
                                                            }}
                                                            sx={{ width: 100 }}
                                                        />

                                                        <Typography variant="h6" textAlign={'center'} sx={{ width: 25 }} color="text.secondary">
                                                            ×
                                                        </Typography>

                                                        <TextField
                                                            size="small"
                                                            type="number"
                                                            label="Height"
                                                            color="secondary"
                                                            placeholder="Height"
                                                            value={height}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (/^\d*\.?\d*$/.test(val)) setHeight(val);
                                                            }}
                                                            sx={{ width: 100 }}
                                                        />
                                                    </Stack>
                                                </Grid>

                                            </Grid>
                                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                                <Grid item xs={4} lg={2}>
                                                    <Typography variant="h6">Max Weight (kg)</Typography>
                                                </Grid>

                                                <Grid item xs={8} lg={4}>
                                                    <TextField
                                                        size="small"
                                                        type="number"
                                                        color="secondary"
                                                        placeholder="Enter Max Weight (kg)"
                                                        value={maxweightinkg}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d*\.?\d*$/.test(val)) setMaxWeightInKg(val);
                                                        }}

                                                    />

                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                                <Grid item xs={4} lg={2}>
                                                    <Typography variant="h6">Max Volume</Typography>
                                                </Grid>

                                                <Grid item xs={8} lg={4}>
                                                    <TextField
                                                        size="small"
                                                        type="number"
                                                        color="secondary"
                                                        placeholder="Enter Max Volume"
                                                        value={maxvolume}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d*\.?\d*$/.test(val)) setMaxVolume(val);
                                                        }}

                                                    />

                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                                <Grid item xs={4} lg={2}>
                                                    <Typography variant="h6">Max Item Count</Typography>
                                                </Grid>

                                                <Grid item xs={8} lg={4}>
                                                    <TextField
                                                        size="small"
                                                        type="number"
                                                        color="secondary"
                                                        placeholder="Enter Max Item Count"
                                                        value={maxitemcount}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            // Allow only whole numbers (no decimals, no negatives)
                                                            if (/^\d*$/.test(val)) {
                                                                setMaxItemCount(val);
                                                            }
                                                        }}

                                                    />

                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                                <Grid item xs={4} lg={2}>

                                                    <Typography variant="h6">Allow Multiple Items</Typography>
                                                </Grid>

                                                <Grid item xs={4} lg={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={allowmixeditems}
                                                                onChange={(e) => setAllowMixedItems(e.target.checked)}
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={allowmixeditems ? 'True' : 'False'}
                                                    />

                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} sx={{ mt: 0 }}>

                                                <Grid item xs={4} lg={2}>

                                                    <Typography variant="h6">Allow Mixed Batches</Typography>
                                                </Grid>

                                                <Grid item xs={2} lg={2}>

                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={allowmixedbatches}
                                                                onChange={(e) => setAllowMixedBatches(e.target.checked)}
                                                                color="secondary"
                                                            />
                                                        }
                                                        label={allowmixedbatches ? 'True' : 'False'}
                                                    />

                                                </Grid>
                                            </Grid>
                                        </>
                                    )}

                                </Grid>
                            </Grid>
                        </Box>

                        {visibleBinlevelConfiguration && (

                            <Box sx={{ mt: 0, p: 1 }}>
                                <Card
                                    elevation={3}
                                    backgroundColor={colors.blueAccent[400]}
                                    color={colors.blueAccent[500]}

                                >
                                    <CardContent sx={{ backgroundColor: colors.primary[400], borderRadius: 2 }}>

                                        <Typography
                                            variant="h5"
                                            sx={{

                                                borderBottom: '2px solid #ec407a',  // Underline color
                                                pb: 1,
                                                mb: 2,
                                                fontWeight: 600,

                                            }}
                                        >
                                            Warehouse Levels Configuration
                                        </Typography>

                                        {levels.map((lvl, i) => (
                                            <Box key={lvl.id} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                {/* Switch Row */}
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={lvl.enabled}

                                                            color="secondary"
                                                        />
                                                    }
                                                    label={<Typography fontWeight={600}>{`${lvl.id}`}</Typography>}
                                                />

                                                {/* Inputs Row */}

                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        mt: 1,
                                                        pl: 0,
                                                    }}
                                                >
                                                    <TextField
                                                        size="small"
                                                        color="secondary"
                                                        disabled
                                                        value={lvl.label}
                                                        onChange={(e) => handleChange(i, 'label', e.target.value)}
                                                        //   sx={{ flex: 1 }}
                                                        label={`${lvl.id} Label`}
                                                        sx={{ mx: 0, width: 200 }}
                                                        InputProps={{
                                                            sx: { borderRadius: '6px', height: '36px' },
                                                        }}
                                                    />

                                                    <TextField
                                                        size="small"
                                                        color="secondary"
                                                        type="number"
                                                        disabled={!lvl.enabled}
                                                        value={lvl.count}
                                                        label="Count"
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d*$/.test(val)) {
                                                                handleChange(i, 'count', val);
                                                            }
                                                        }}
                                                        sx={{ width: 80 }}
                                                        InputProps={{
                                                            sx: { borderRadius: '6px', height: '36px' },
                                                        }}
                                                    />
                                                </Box>

                                            </Box>
                                        ))}

                                        <Typography variant="subtitle1" sx={{ mt: 3 }}>
                                            Total Warehouse levels will create: {totalCombinations}
                                        </Typography>
                                    </CardContent>

                                </Card>
                            </Box>

                        )}



                        {/* <Divider sx={{ marginTop: "0px" }} /> */}

                        {locationTableData.length > 0 && (



                            <Box sx={{ mt: 0, p: 1 }}>
                                <Grid item xs={12} sm={12} md={5} lg={12} xl={12} display="flex-start" >
                                    <Box sx={{ padding: 1 }}>

                                        <Typography
                                            variant="h5"
                                            sx={{

                                                borderBottom: '2px solid #ec407a',  // Underline color
                                                pb: 1,
                                                mb: 0.5,
                                                fontWeight: 600,

                                            }}
                                        >
                                            Location Details
                                        </Typography>

                                        <ResponsiveBox
                                            customMaxHeight={{
                                                xs: '72vh', // Extra small devices (phones)
                                                sm: '72vh', // Small devices (tablets)
                                                md: '74vh', // Medium devices (small laptops)
                                                lg: '50vh', // Large devices (desktops)
                                                xl: '82vh', // Extra large devices (large desktops)
                                            }}>


                                            {/* <TableContainer sx={{ mt: 0, }}>

                                                    {loading ? (
                                                        <SkeletonTableLoader rows={5} columns={11} />
                                                    ) : (

                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Location Code</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Width (cm)</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }} >Length (cm)</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Height (cm)</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Max Wt. (kg)</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Max Vol.</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Max Items</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Mixed Items</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Mixed Batches</TableCell>
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {locationTableData.map((row) => (
                                                                    <TableRow key={row.location_id}>

                                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>{row.code}</TableCell>

                                                                        
                                                                        {[
                                                                            "length_in_cm",
                                                                            "width_in_cm",
                                                                            "height_in_cm",
                                                                            "max_weight_in_kg",
                                                                            "max_volume",
                                                                            "max_item_count",
                                                                        ].map((field) => (
                                                                            <TableCell key={field} align="right">
                                                                                <TextField
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    type="number"
                                                                                    value={row[field] ?? ""}
                                                                                    onChange={(e) =>
                                                                                        handleFieldChange(
                                                                                            row.location_id,
                                                                                            field,
                                                                                            e.target.value === "" ? "" : Number(e.target.value)
                                                                                        )
                                                                                    }
                                                                                    onWheel={(e) => e.preventDefault()}
                                                                                    InputProps={{
                                                                                        inputProps: { style: { textAlign: 'right' } }
                                                                                    }}
                                                                                    sx={{
                                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                                            border: 'none',
                                                                                        },
                                                                                        '& .MuiInputBase-input': {
                                                                                            padding: '8px',
                                                                                            textAlign: 'center',
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                        ))}



                                                                        <TableCell align="center">
                                                                            <Checkbox
                                                                                size="small"
                                                                                checked={row.allow_mixed_item}
                                                                                onChange={() =>
                                                                                    handleSwitchChange(row.location_id, "allow_mixed_item")
                                                                                }
                                                                                color="secondary"
                                                                            />

                                                                        </TableCell>

                                                                        <TableCell align="center">
                                                                            <Checkbox
                                                                                size="small"
                                                                                checked={row.allow_mixed_batches}
                                                                                onChange={() =>
                                                                                    handleSwitchChange(row.location_id, "allow_mixed_batches")
                                                                                }
                                                                                color="secondary"
                                                                            />
                                                                        </TableCell>

                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    )}
                                                </TableContainer>  */}

                                            <Box sx={{ height: 400, overflow: 'auto' }}>
                                                <DataGrid
                                                    rows={rows}
                                                    columns={columns}
                                                    rowHeight={40}
                                                    disableRowSelectionOnClick

                                                    experimentalFeatures={{ newEditingApi: true }}
                                                    processRowUpdate={(newRow, oldRow) => {
                                                        const field = Object.keys(newRow).find(k => newRow[k] !== oldRow[k]);
                                                        handleFieldChange(newRow.location_id, field, newRow[field]);
                                                        return newRow;
                                                    }}
                                                    sx={(theme) => ({
                                                        border: `1px solid ${theme.palette.divider}`,

                                                        "& .MuiDataGrid-columnHeaders": {
                                                            backgroundColor: theme.palette.action.hover,
                                                            fontSize: "14px",
                                                            fontWeight: 600,
                                                            position: "sticky",
                                                            top: 0,
                                                            zIndex: 10
                                                        },

                                                        "& .MuiDataGrid-cell": {
                                                            fontSize: "14px",
                                                            borderBottom: `1px solid ${theme.palette.divider}`,
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }
                                                    })}
                                                />

                                            </Box>


                                        </ResponsiveBox>

                                        {/* {binUsage.length > 0 && (
  <Box mt={1} p={2} sx={{
      border: "1px solid #87a5c2ff",
      borderRadius: "10px"
  }}>
    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
      Bin Usage Details
    </Typography>

    <Divider />

    <Box display="flex" flexDirection="column" gap={1} mt={2}>
      <Typography><b>Stackable:</b> {binUsage[0].is_stackable ? "Yes" : "No"}</Typography>
      <Typography><b>Gap (cm):</b> {binUsage[0].vertical_gap_in_cm}</Typography>
      <Typography><b>Used L (cm):</b> {binUsage[0].used_length_in_cm}</Typography>
      <Typography><b>Used H (cm):</b> {binUsage[0].used_height_in_cm}</Typography>
      <Typography><b>Item Count:</b> {binUsage[0].used_item_count}</Typography>
    </Box>
  </Box>
)} */}

                                        <Dialog
                                        sx={{
    
    }}
                                        
                                            open={Boolean(binUsagePopup)}
                                            onClose={() => setBinUsagePopup(false)}
                                            maxWidth="xs"
                                            fullWidth
                                        >
                                            <DialogTitle 
                                            > <Typography variant="h5" sx={{ fontWeight: 600, mb: 0 }}>
                                                    Bin Usage Details
                                                </Typography></DialogTitle>

                                            {binUsage && binUsage.length > 0 && (
                                                <DialogContent dividers>
                                                    <Box display="flex" flexDirection="column" gap={1}>
                                                        <Typography>Stackable: <b> {binUsage[0].is_stackable ? "Yes" : "No"}</b></Typography>
                                                        <Typography>Gap (cm):<b> {binUsage[0].vertical_gap_in_cm}</b></Typography>
                                                        <Typography>Used Length (cm):<b> {binUsage[0].used_length_in_cm}</b></Typography>
                                                        <Typography>Used Height (cm):<b> {binUsage[0].used_height_in_cm}</b></Typography>
                                                        <Typography>Used Item Count:<b> {binUsage[0].used_item_count}</b></Typography>
                                                    </Box>
                                                </DialogContent>
                                            )}

                                            <DialogActions>
                                                <Button size="small" startIcon={<Cancel/>} onClick={() => setBinUsagePopup(false)} sx={{ color:'rgba(192, 101, 107, 0.93)' }} variant="contained">
                                                    Close
                                                </Button>
                                            </DialogActions>

                                        </Dialog>



                                    </Box>




                                </Grid>

                            </Box>



                        )}

                    </ResponsiveBox>
                </Box>
            )}

            {isWarehouseOpen && (
                <AddNewWarehouse
                    handleBackWinderMachineEntry={handleBack}
                    selectedwarehosue={null}
                />
            )}

            {isBintypeOpen && (
                <AddNewBintypeMaster
                    handleBackWinderMachineEntry={handleBack}
                    selectedwarehosue={null}
                />
            )}


            {isLocationtypeOpen && (
                <WHAddUpdateLocationType
                    locationFormData={locationFormData}
                    setLocationFormData={setLocationFormData}
                    setIsFormOpen={setIsLocationtypeOpen}
                    LoadLocationList={loadStorageLocationTypeByID}
                />
            )}
        </>
    );
};
export default AddNewStorageLocation; 